<template>
    <div class="container">
        <modallogin v-show="isModalVisible" @close="closeModal"></modallogin>

        <section class="content-header" style="padding:15px;">
            <h1>{{$t('アカウントの削除')}}</h1>
            <p>{{$t('アカウントを削除すると、元に戻すことはできません。お気に入りに保存した記事などはすべて削除されます。')}}</p>
        </section>

        <div class="warning" id="warning" v-if="errors.length">
            <ul>
                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
        </div>

        <section class="content-wrap">
            <div class="col-center">
                <button id="removeConfirm" @click="deleteUserAccount" class="btn-remove-account">
                    {{$t('アカウントの削除')}}
                </button>
                <button id="removeCancell" @click="cancelOperation" class="btn-cancel-remove" >
                    {{$t('キャンセル')}}
                </button>
            </div>
        </section>
    </div>
</template>


<script>
import User from "@/api/user";
import modallogin from '@/components/ReAuthenticate'
import {deleteUserFromFirebase} from '@/auth/user-meta'
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";

const loader = document.getElementById("loading");

export default {
    components:{
        modallogin
    },    
    data: () => ({
        errors: [],
        isModalVisible: false,
        executeAfterReLogin: '',
    }),
    computed: {
        ...mapState(["clips", "user"]),
        ...mapGetters({
            email: "email",
            token: "token",
            lang_id: "languageId",
            languageName: "languageName",
            userId: "userId",
            userAttributes: "userAttributes",
            matcaCategoryList: "matcaCategoryList",
            userInterestList: "userInterestList",
            userInterestedCategory: "userInterestedCategory",
            userMeta:"userMeta",
            reAuthenticationRequire: "reAuthenticationRequire"
        })
    },
    methods: {
        reAuthenticationOperation(){
            if(this.executeAfterReLogin){
                loader.style.display = "block";
                this.$store.dispatch('updateUser')
                    .then(res => {
                        if(this.executeAfterReLogin === "deleteUserAccount"){
                            this.deleteUserAccount()
                            this.executeAfterReLogin = ''
                        }else{
                            window.location.href = '/'
                        }
                    })
                    .catch(err => {
                        loader.style.display = "none";
                        window.location.href = '/'
                    })
            }else{
                window.location.href = '/'
            }       
        },        
        cancelOperation() {
            this.$router.push("/settings");
        },

        deleteUserAccount() {
            if(this.reAuthenticationRequire){
                this.showModal()
                this.executeAfterReLogin = 'deleteUserAccount';
                return
            }

            loader.style.display = "block";
            this.errors = [];
            let bodyParams = { email: this.email }

            // Delete User From MATCHA DB
            User.deleteUser(bodyParams, this.token)
                .then(response => {
                    // console.log(response)

                    // Delete User From Firebase Side
                    deleteUserFromFirebase()
                        .then(res => {
                            // console.log(res)
                            this.$store.dispatch('setReAuthenticationFlag', true)
                            loader.style.display = "none";
                            this.$swal({
                                text: this.$t( "アカウントの削除が完了しました。"),
                                type: "success"
                            }).then(() => {
                                window.location.reload(true);
                            })
                            
                        })
                        .catch(err => {
                            // console.log(err)
                            if(err.code == 'auth/requires-recent-login'){
                                loader.style.display = "none";
                                this.showModal()
                            }else{
                                loader.style.display = "none";
                                this.errors.push = this.$t(err.message);
                            }                    
                            
                        })
                })
                .catch(error => {
                    // console.log(error)
                    loader.style.display = "none";
                    this.errors.push = error.data.message;
                });
        },

        showModal() {
            this.isModalVisible = true;
        },

        closeModal() {
            this.isModalVisible = false;
        },

    },

    //For Header & Meta Tag
    metaInfo() {
        return {
            title:
                this.$t("アカウントの削除") + " | MATCHA - JAPAN TRAVEL WEB MAGAZINE",
            htmlAttrs: {
                lang: this.$store.state.languageName
            }
        };
    }
};
</script>

<style>
    .col-center{
        text-align : center;
    }
    .btn-remove-account{
        background-color: #F44336 !important;
        font-size: 14px;
    }
    .btn-cancel-remove{
        font-size: 14px;
    }
    @media screen and (max-width: 979px){
        .btn-remove-account{
            width: auto !important;
            margin: 12px 0 1px !important;
        }
        .btn-cancel-remove{
            width: auto !important;
            margin: 12px 0 1px !important;
        }        
    }

</style>


// WEBPACK FOOTER //
// src/pages/settings/deleteaccount.vue